import { pb } from '@/libs/pocketbase'
import type { TeamMembershipPort } from '../domain/team-membership'

// team_members is the source of truth for team membership. We read it directly
// here and expose only the team ids, so the user record carries no denormalized
// team_ids field that could drift out of sync.
const pbTeamMembershipAdapter: TeamMembershipPort = {
	listTeamIdsForUser: userId =>
		pb
			.collection('team_members')
			.getFullList({ filter: pb.filter('user_id = {:userId}', { userId }), requestKey: null })
			.then(records => records.map(record => record['team_id'] as string)),
}

export { pbTeamMembershipAdapter }
